import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { money } from "~hooks/useHelpers";
import { SimulatorsEdit, SimulatorsTrash } from "~misc/icons";

import "./style.scss";

const ProdutoItem = ({ product, indexGP, index, simulador, prazoPagamento, prazoRegra }) => {
  const [activeAccordion, setActiveAccordion] = useState(false);
  const [servicos, setServicos] = useState()
  const { removeProduto, quantidadeProduto, setEdit, desconto, simulacao } = simulador;
  const colors = {
    negativo: "#01AE3C",
    positivo: "#FF2E00",
  };

  const fobColRef = useRef(null);
  const cifColRef = useRef(null);
  const [paddingLeft, setPaddingLeft] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setPaddingLeft(fobColRef.current?.offsetLeft);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getFracionamento = () => {
    const { pesoLiquido: peso } = product?.produtoOriginal || {};
    const fracionamento = parseFloat(product?.fracionamento);

    return peso && fracionamento
      ? (fracionamento / 1000) * parseFloat(peso)
      : fracionamento;
  };

  useEffect(() =>{
    let vFracionamento  =  product?.fracionamento > 0 && simulacao.fracionamento === true ? getFracionamento(): 0
    let vDescarga = product?.descargaManual > 0 && simulacao?.descargaManual === true ? product?.descargaManual : 0
    setServicos(vFracionamento + vDescarga)
  }, [simulacao.fracionamento, simulacao.descargaManual, simulacao])

  const descontoCif = useMemo(() => {
    if (!product?.desconto?.cif) return 0;
    if (typeof product?.desconto?.cif === 'string' || product?.desconto?.cif instanceof String) {
      return parseFloat(product?.desconto?.cif.replace(",", "."))?.toFixed(2);
    }

    return product?.desconto?.cif?.toFixed(2);
  }, [product?.desconto?.cif]);

  const descontoFob = useMemo(() => {
    if (!product?.desconto?.fob) return 0;
    if (typeof product?.desconto?.fob === 'string' || product?.desconto?.fob instanceof String) {
      return parseFloat(product?.desconto?.fob.replace(",", "."))?.toFixed(2);
    }

    return product?.desconto?.fob?.toFixed(2);
  }, [product?.desconto?.fob]);

  const precoFinalCif = useMemo(() => {
    if (!product?.precoFinal?.cif) return 0;
    if (typeof product?.precoFinal?.cif === 'string' || product?.precoFinal?.cif instanceof String) {
      return parseFloat(product?.precoFinal?.cif);
    }

    return product?.precoFinal?.cif;
  }, [product?.precoFinal?.cif ]);

  const precoFinalFob = useMemo(() => {
    if (!product?.precoFinal?.fob) return 0;
    if (typeof product?.precoFinal?.fob === 'string' || product?.precoFinal?.fob instanceof String) {
      return parseFloat(product?.precoFinal?.fob);
    }

    return product?.precoFinal?.fob;
  }, [product?.precoFinal?.fob ]);

  return (
    <>
      <Tr>
        <Td>{product?.produto}</Td>
        <Td>{product?.filial ?? "a definir"}</Td>
        <Td maxW={100}>
          <NumberInput
            min={0}
            defaultValue={product?.quantidade || 1}
            onChange={(valueString) => quantidadeProduto(indexGP, index, valueString)}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </Td>
        <Td textAlign={"center"} ref={fobColRef}>
          {money(precoFinalFob + (product?.beneficioFis?.fob || 0) ?? 0)}
        </Td>
        <Td textAlign={"center"} ref={cifColRef}>
          {money(servicos + precoFinalCif + (product?.beneficioFis?.cif || 0) ?? 0)}
        </Td>
        <Td textAlign={"center"}>{prazoPagamento ? prazoPagamento : prazoRegra}</Td>
        <Td>
          <Flex alignItems="center" gap={2} justifyContent="space-between">
            <Flex gap={2}>
              <Button type="button" variant="link" onClick={() => setEdit(indexGP, index)}>
                <SimulatorsEdit size="40" />
              </Button>
              <Button type="button" variant="link" onClick={() => removeProduto(indexGP, index)}>
                <SimulatorsTrash size="40" />
              </Button>
            </Flex>
          </Flex>
        </Td>
      </Tr>
      <Tr>
        <Td colSpan={7} className="!p-0">
          <Accordion allowMultiple className="border-0 p-0">
            <AccordionItem className="produto-item">
              <AccordionButton onClick={() => setActiveAccordion((prev) => !prev)}>
                <Box as="span" flex="1" textAlign="center" fontWeight="bolder">
                  {activeAccordion ? "Exibir menos" : "Exibir mais"}
                  <AccordionIcon />
                </Box>
              </AccordionButton>

              <AccordionPanel
                p={0}
                whiteSpace="wrap"
                bg="#E6E6EE"
                style={{ paddingLeft: `${paddingLeft > 0 ? paddingLeft : fobColRef.current?.offsetLeft}px` }}
                className="produto-item-content"
              >
                {product?.precoRegra?.fob !== undefined && product?.precoRegra?.cif !== undefined && (
                  <Flex className="produto-item-content-row">
                    <div>
                      <Text textAlign="right">Preço Regra</Text>
                    </div>
                    <div style={{ width: `${fobColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center">{money(product?.precoRegra?.fob)}</Text>
                    </div>
                    <div style={{ width: `${cifColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center">{money(product?.precoRegra?.cif)}</Text>
                    </div>
                  </Flex>
                )}
                {descontoFob !== undefined && product?.desconto?.cif !== undefined && (descontoFob != 0 || descontoCif != 0) &&(
                  <Flex className="produto-item-content-row">
                    <div>
                      <Text textAlign="right">
                        {product?.condicao == "Faixa" && (
                          <>
                            Desconto{" "}
                            <strong>
                              ({product?.condicao}: {descontoFob ?? 0}%)
                            </strong>
                          </>
                        )}

                        {product?.condicao == "Condição Especial" && (
                          <>
                            Desconto{" "}
                            <strong>
                              ({product?.condicao}{" "}
                              {descontoFob != 0 && <>FOB:{descontoFob ?? 0}%</>}

                              {descontoFob != 0 && descontoCif != 0 && " / "}

                              {descontoCif != 0 && <>CIF:{descontoCif ?? 0}%</>})
                            </strong>
                          </>
                        )}
                      </Text>
                    </div>

                    <div style={{ width: `${fobColRef.current?.offsetWidth}px` }}>
                      <Text
                        textAlign="center"
                       color={colors.negativo}>
                        {(product?.precoRegra?.fob ?? 0) != (precoFinalFob ?? 0) && (
                          <>{desconto(product?.precoRegra?.fob ?? 0, precoFinalFob ?? 0)}</>
                        )}
                      </Text>
                    </div>

                    <div style={{ width: `${cifColRef.current?.offsetWidth}px` }}>
                      <Text
                        textAlign="center"
                        color={colors.negativo}>
                        {(product?.precoRegra?.cif ?? 0) != (precoFinalCif ?? 0) && (
                          <>{desconto(product?.precoRegra?.cif ?? 0, precoFinalCif ?? 0)}</>
                        )}
                      </Text>
                    </div>

                  </Flex>
                )}

                {product?.fracionamento > 0 && simulacao.fracionamento === true && (
                  <Flex className="produto-item-content-row">
                    <div>
                      <Text textAlign="right">Fracionamento</Text>
                    </div>
                    <div style={{ width: `${fobColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center" color="black">
                        {money(0)}
                      </Text>
                    </div>
                    <div style={{ width: `${cifColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center" color={colors.positivo}>
                        +{money(getFracionamento())}
                      </Text>
                    </div>
                  </Flex>
                )}
                {product?.descargaManual > 0 && simulacao?.descargaManual === true && (
                  <Flex className="produto-item-content-row">
                    <div>
                      <Text textAlign="right">Descarga</Text>
                    </div>
                    <div style={{ width: `${fobColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center" color="black">
                        {money(0)}
                      </Text>
                    </div>
                    <div style={{ width: `${cifColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center" color={colors.positivo}>
                        +{money(product?.descargaManual)}
                      </Text>
                    </div>
                  </Flex>
                )}

                {product?.beneficioFis?.fob !== undefined && product?.beneficioFis?.cif !== undefined && (
                  <Flex className="produto-item-content-row">
                    <div>
                      <Text textAlign="right">Benefício fiscal</Text>
                    </div>
                    <div style={{ width: `${fobColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center" color="#01AE3C">
                        {money(product?.beneficioFis?.fob)}
                      </Text>
                    </div>
                    <div style={{ width: `${cifColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center" color="#01AE3C">
                        {money(product?.beneficioFis?.cif)}
                      </Text>
                    </div>
                  </Flex>
                )}

                {product?.precoFi?.fob !== undefined && product?.precoFi?.cif !== undefined && (
                  <Flex className="produto-item-content-row">
                    <div>
                      <Text textAlign="right">Preço Final</Text>
                    </div>
                    <div style={{ width: `${fobColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center">{money(product?.precoFi?.fob)}</Text>
                    </div>
                    <div style={{ width: `${cifColRef.current?.offsetWidth}px` }}>
                      <Text textAlign="center">{money(product?.precoFi?.cif)}</Text>
                    </div>
                  </Flex>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Td>
      </Tr>
    </>
  );
};

export default ProdutoItem;
